import { render, staticRenderFns } from "./navbarScreening.vue?vue&type=template&id=354f7090&"
import script from "./navbarScreening.vue?vue&type=script&lang=js&"
export * from "./navbarScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports